import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    IonCard,
    IonCardContent,
    IonImg,
    IonPage,
    IonContent
} from '@ionic/react';
import { AuthenticationState, useAuth } from '../components/auth/contexts/AuthContext';
import { RegisterForm } from '../components/auth/components/RegisterForm';

export const Register: React.FC = () => {
    const { authState } = useAuth();
    const history = useHistory();
    const location = useLocation();

    // Get the return URL from location state, default to '/'
    const from = (location.state as any)?.from?.pathname || '/';

    // Redirect if already authenticated
    useEffect(() => {
        if (authState === AuthenticationState.AUTHENTICATED) {
            history.replace(from);
        }
    }, [authState, history, from]);

    return (
        <IonPage>
            <IonContent className="ion-padding">
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    minHeight: '100%' 
                }}>
                    <IonCard style={{ width: '100%', maxWidth: '400px' }}>
                        {/* Logo */}
                        <IonImg
                            src="/logo.png"
                            alt="LinkSharePro Logo"
                            style={{
                                width: '200px',
                                margin: '2rem auto'
                            }}
                        />

                        <IonCardContent>
                            <RegisterForm />
                        </IonCardContent>
                    </IonCard>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Register; 